import clsx from 'clsx';
import styles from 'components/UI/V3/Timeline/Timeline.module.scss';
import React from 'react';

interface TimelineProps {
    children?: React.ReactNode;
    className?: string;
}

export const Timeline: React.FC<TimelineProps> = ({ children, className }) => {
    return <div className={clsx(styles.root, className)}>{children}</div>;
};
